<ngx-spinner
  bdColor="rgba(250, 250, 250, 0.9)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  template="<div class='loader-box show' ><div id='loader'><div class='circle-loader'><div class='circle circle-1'></div><div class='circle circle-2'></div><div class='circle circle-3'></div><div class='circle circle-4'></div></div></div>
  <style>
    .loader-box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      opacity: 0; /* Başlangıçta gizle */
      pointer-events: none; /* Tıklanmaz hale getir */
      transition: opacity 0.5s ease, visibility 0.5s ease; /* Geçiş ekleyelim */
    }

    .loader-box.show {
      opacity: 1; /* Yalnızca 'show' sınıfı eklenince görünür */
      pointer-events: auto; /* Tıklanabilir hale getir */
    }
    .loader-box.ng-leave {
      opacity: 0;
      pointer-events: none;
    }

    #loader {
      width: 100%;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .circle-loader {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .circle {
      position: absolute;
      border: 3.5px solid transparent;
      border-radius: 50%;
      animation: rotate 3s infinite ease-in-out;
    }

    .circle-1 {
      width: 250px;
      height: 250px;
      border-top-color: #0c9;
      border-right-color: #0c9;
      animation-delay: -0.15s;
    }

    .circle-2 {
      width: 200px;
      height: 200px;
      border-top-color: #0d1a36;
      border-right-color: #0d1a36;
      animation-delay: -0.3s;
    }

    .circle-3 {
      width: 150px;
      height: 150px;
      border-top-color: #0c9;
      border-right-color: #0c9;
      animation-delay: -0.45s;
    }

    .circle-4 {
      width: 100px;
      height: 100px;
      border-top-color: #0d1a36;
      border-right-color: #0d1a36;
      animation-delay: -0.6s;
    }

    @keyframes rotate {
      50% {
        transform: rotate(360deg);
      }
    }

    .timer-text {
      position: absolute;
      font-size: 48px;
      color: black;
    }
  </style>"
>
  <p style="font-size: 20px; color: white"></p>
</ngx-spinner>
<script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="c81b4265-6da7-4395-887c-e0df2647e8bc" data-blockingmode="auto" type="text/javascript"></script>
<div class="topbar" *ngIf="showLayout">
  <div class="container">
    <div class="col-12 col-sm-8 col-md-8 col-lg-10">
      <!-- Topbar Contact Information Start -->
      <div class="topbar-contact-info">
        <ul *ngIf="contact">
          <li>
            <span>Senkatur Turizm Seyahat Acentesi </span>
          </li>
          <li>
            <!-- <img src="../assets/images/tursabLogo.png" alt="" style="max-width:13px !important"/> -->
            <span>İşletme Belge No: </span><a>{{TursabBelgeNo}}</a>
          </li>

          <li class="md-none">
            <img style="width: 20px" src="https://evisa-react.xpressbuddy.com/static/media/time.5e3be575be4be2f0ee29979f427cb019.svg" alt="" />
            <span>Çalışma Saatleri:</span> 09:00 - 18:00
          </li>
           <li class="md-none">
            <img src="../assets/images/icon-mail2.svg" alt="" />
            <span>Email:</span><a [href]="'mailto:' + contact?.email" target="_blank">{{ contact?.email }}</a>
          </li>
        </ul>
      </div>
      <!-- Topbar Contact Information End -->
    </div>

    <div class="col-lg-2">
      <!-- Header Social Icons Start -->
      <div class="topbar-social-icons">
        <ul>
          <li *ngIf="Instagram">
            <a [href]="Instagram" target="_blank"><i class="fa-brands fa-instagram"></i></a>
          </li>
          <li *ngIf="Facebook">
            <a [href]="Facebook" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
          </li>
          <li *ngIf="YouTube">
            <a [href]="YouTube" target="_blank"><i class="fa-brands fa-youtube"></i></a>
          </li>
          <li *ngIf="LinkedIn">
            <a [href]="LinkedIn" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
          </li>
          <li *ngIf="Twitter">
            <a [href]="Twitter" target="_blank"><i class="fa-brands fa-twitter"></i></a>
          </li>
          <li>
            <!-- <a style="margin-right:20px" href="https://senkatur.com/index" target="_blank"><img style="max-width:80px" src="../assets/images/logoSenka.png" alt="" /></a> -->
          </li>
        </ul>
      </div>
      <!-- Header Social Icons End -->
    </div>
  </div>
</div>

<header id="header" *ngIf="showLayout">
  <div class="header-top">
    <div class="container">
      <div class="col-2 col-md-3 col-lg-2">
        <div class="logo" routerLink="/" style="cursor: pointer">
          <a routerLink="/">
            <img src="../assets/images/vize-asist.png" alt="Logo" />
          </a>
        </div>
      </div>
      <nav class="col-10 col-md-9 col-lg-10">
        <ul [class.open]="menuOpen" class="navbar">
          <li><a routerLink="/" (click)="toggleMenu()">Anasayfa</a></li>
          <li>
            <a routerLink="hakkimizda" (click)="toggleMenu()">Kurumsal</a>
          </li>
          <li>
            <a routerLink="sikca-sorulan-sorular" (click)="toggleMenu()">SSS</a>
          </li>
          <li><a routerLink="blog" (click)="toggleMenu()">Blog</a></li>

          <li><a routerLink="iletisim" (click)="toggleMenu()">İletişim</a></li>
          <li><a routerLink="interrogate" (click)="toggleMenu()">Başvuru Sorgula</a></li>
        </ul>

        <div class="evaluate-btn">
          <button style="padding-right: 30px" (click)="openVisa()"><img class="diamond" src="../assets/images/passport2.gif" alt="Vize Al" />Vize Al</button>
        </div>
        <div class="hamburger" (click)="toggleMenu()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </div>
  </div>

  <div *ngIf="isShow" class="header-bottom">
    <div class="overlay"></div>
    <div class="container header-middle">
      <div class="col-12 col-md-6">
        <span class="b-text">Haydi, vizenizi en<span style="color: #0c9">kolay</span> ve <span style="color: #0c9"> güvenilir </span> şekilde alın!</span>
        <h6 class="s-text">Uzman desteğiyle hızlı başvuru, sorunsuz sonuç. Belgelerinizi yükleyin, gerisini biz halledelim!</h6>
        <div class="home-search box">
          <div class="steps">
            <h1>Hemen Başvur</h1>
            <h5>Bekleme, Vizeni Al.</h5>
            <div class="content"><img class="img-pss" src="../assets/images/pss.jpg" alt="Rental Vehicle" /><img class="two" src="../assets/vectors/Vector-3.svg" alt="vektor" /></div>
          </div>
          <div class="form-container">
            <ngx-select-dropdown
              [instanceId]="'instance1'"
              (change)="onChangeVisaCountry($event)"
              [(ngModel)]="ngModelVisaCountry"
              [multiple]="false"
              [config]="configCountry"
              [options]="dropdownOptionsCountry"
              [_value]="33"
              class="select-box"
            ></ngx-select-dropdown>
            <div *ngIf="showVisaCountryRequired" style="color: red">*</div>
            <ngx-select-dropdown
              [instanceId]="'instance1'"
              (change)="onChangeVisitReason($event)"
              [(ngModel)]="ngModelVisaReason"
              [multiple]="false"
              [config]="configVisaType"
              [options]="dropdownOptionsVisitReason"
              class="select-box"
            ></ngx-select-dropdown>
            <div *ngIf="showVisitReasonRequired" class="error" style="color: red">*</div>
            
            <ngx-select-dropdown
              *ngIf="ngModelVisaCountry && ngModelVisaCountry.id == 33"
              [instanceId]="'instance1'"
              (change)="onChangeVisaType($event)"
              [(ngModel)]="ngModelVisaType"
              [multiple]="false"
              [config]="configVisaTime"
              [options]="dropdownOptionsVisaType"
              class="select-box"
            ></ngx-select-dropdown>
            <div *ngIf="showVisaTypeRequired" class="error" style="color: red">*</div>
            <button type="button" (click)="search()">Devam Et</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 slider">
        <app-home-slider></app-home-slider>
      </div>
    </div>
  </div>
</header>
<main>
  <router-outlet></router-outlet>
</main>
<footer *ngIf="showLayout">
  <div class="container">
    <div class="row">
      <div class="col-md-4 footer-contact">
        <img src="../assets/images/vize-asist.png" alt="Logo" />

        <div style="margin-top: 25px">
          <ul class="footer__cta list-unstyled mt-50">
            <li class="ul_li">
              <span><img src="../assets/images/footer-call.svg" alt="" /></span>
              <a [href]="'tel:' + contact?.phone" class="footeraColorPhone">{{ contact?.phone }}</a>
            </li>
            <li class="ul_li">
              <span><img src="../assets/images/footer-mail.svg" alt="" /></span>
              <a [href]="'mailto:' + contact?.email" class="footeraColorMail" target="_blank">{{ contact?.email }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-5 footer-links">
        <div class="links-top">
          <ul class="left-menu">
            <li><a routerLink="/">Anasayfa</a></li>
            <li><a routerLink="blog">Blog</a></li>
            <li><a routerLink="hakkimizda">Kurumsal</a></li>
            <li><a routerLink="iletisim">İletişim</a></li>
          </ul>
          <ul class="right-menu">
            <li><a (click)="openVisa()" style="cursor: pointer">Vize Al</a></li>
            <li>
              <a routerLink="interrogate">Başvuru Sorgula</a>
            </li>
            <li><a routerLink="sikca-sorulan-sorular">Sıkça Sorulan Sorular</a></li>
            <!-- <li><a routerLink="/politikalar-ve-kvkk-dokumanlari/iptal-ve-iade-kosullari">İptal ve İade</a></li>  -->
            <li><a routerLink="/politikalar-ve-kvkk-dokumanlari/hukum-ve-kosullar">İptal ve İade</a></li>
          </ul>
        </div>
        <div class="links-bottom">
          <a routerLink="politikalar-ve-kvkk-dokumanlari">Gizlilik Politikaları</a>
          <a routerLink="politikalar-ve-kvkk-dokumanlari/aydinlatma-metni">Aydınlatma Metni</a>
          <a routerLink="politikalar-ve-kvkk-dokumanlari/hukum-ve-kosullar">Hüküm ve Koşullar</a>
        </div>
      </div>
      <div class="col-md-3 footer-right-links">
        <div class="footer-social" style="text-align: right">
          <a href="https://www.tursab.org.tr/tr/ddsv" target="_blank">
            <img src="tursab-dds-11804.png" alt="TÜRSAB Dijital Doğrulama Sistemi" style="max-width: 160px; margin-bottom: 10px" />
          </a>
        </div>
        <div class="companysnlg">
          <!-- <a href="https://senkatur.com/index" target="_blank">
            <img src="../assets/images/logoSenka.png" alt="Senka Logo" style="max-width:120px; vertical-align:middle;" />
          </a> -->
          <p>Senkatur Turizm Seyahat Acentesi</p>
        </div>
        <div class="payment-icons" style="display: flex; justify-content: flex-end; margin-right: 30px; margin-top: 0px !important; gap: 12px; margin: 10px 0">
          <img src="../assets/images/money.png" alt="Money" style="height: 32px" />
          <img src="../assets/images/visa.png" alt="Visa" style="height: 32px" />
          <img src="../assets/images/amex.png" alt="Amex" style="height: 32px" />
        </div>
        <div class="info-company" style="display: flex; align-items: center; justify-content: flex-end; margin-right: -10px">
          <a href="https://www.sanalogi.com" target="_blank">
            <svg
              version="1.1"
              id="katman_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 335.7 81.7"
              style="height: 15px; enable-background: new 0 0 335.7 81.7"
              xml:space="preserve"
            >
              <style type="text/css">
                .st3 {
                  fill: #0d6efd;
                }

                .st2 {
                  fill: #0d6efd;
                }
              </style>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <rect y="72.2" class="st3" width="32.7" height="9.4" />
                      </g>
                      <g>
                        <rect x="41.6" class="st3" width="32.7" height="9.5" />
                      </g>
                      <g>
                        <polygon
                          class="st3"
                          points="41.6,81.7 41.6,72.2 64.3,72.2 64.9,71.7 64.9,28.5 64.3,27.9 55.5,27.9 55.5,18.4 74.2,18.4
						74.2,81.7 					"
                        />
                      </g>
                      <g>
                        <polygon class="st3" points="0,63.2 0,0 32.7,0 32.7,9.5 10,9.5 9.5,10 9.5,53.3 10,53.9 19.8,53.9 19.8,63.2 					" />
                      </g>
                    </g>
                    <g>
                      <path
                        class="st3"
                        d="M35.2,63c-1.1,0-2.2-0.1-3.3-0.3h-0.1l-0.1-8.3h0.1c1.1,0.2,2.2,0.3,3.3,0.3c2.6,0,6.5-0.6,10.2-3.3
					c1.8-1.3,3-2.7,3.5-4.1c0.4-1.3,0.3-2.5-0.4-3.5c-0.6-0.8-1.4-1.1-2.5-1.1c-1.8,0-4.3,1-7,2.1c-1.3,0.5-2.5,1.1-3.9,1.5
					c-2.7,1-4.8,1.5-6.7,1.5c-3.3,0-5.9-1.4-8.1-4.2c-2-2.6-2.9-5.6-2.5-8.6c0.6-4.1,3.4-8,8-11.3c4.7-3.4,9.5-5.1,14.4-5.1
					c1.1,0,2.2,0.1,3.3,0.3h0.1l0.1,8.3h-0.1c-1.1-0.2-2.2-0.3-3.3-0.3c-2.6,0-6.5,0.6-10.2,3.3c-3.4,2.4-4.6,5.4-3.1,7.6
					c0.6,0.8,1.4,1.1,2.5,1.1c1.8,0,4.3-1,6.9-2.1c3.4-1.4,7.2-3,10.9-3c1.4,0,2.8,0.3,4,0.8c0.2,0.1,0.6,0.3,0.9,0.5
					c1.1,0.7,2.1,1.7,3,2.9c2.2,3.1,2.9,6.5,2.1,9.9c-0.9,3.6-3.5,7.1-7.7,10.1C44.8,61.4,40,63,35.2,63z"
                      />
                    </g>
                  </g>
                  <path
                    class="st3"
                    d="M99.7,56.8l4.8-6.8c2.9,3,7.4,5.6,13,5.6c4.9,0,7.1-2.2,7.1-4.6c0-7.1-23.6-2.2-23.6-17.6
			c0-6.8,5.9-12.5,15.6-12.5c6.5,0,11.9,2,16,5.7l-4.9,6.5c-3.3-3.1-7.8-4.5-11.9-4.5c-3.7,0-5.8,1.6-5.8,4.1
			c0,6.5,23.6,2.1,23.6,17.4c0,7.5-5.4,13.2-16.4,13.2C109.2,63.3,103.6,60.7,99.7,56.8z"
                  />
                  <path
                    class="st3"
                    d="M157.6,62.6v-3.1c-2,2.5-5.5,3.9-9.4,3.9c-4.7,0-10.3-3.2-10.3-9.8c0-7,5.5-9.6,10.3-9.6c4,0,7.4,1.3,9.4,3.6
			v-3.8c0-3-2.6-5-6.5-5c-3.1,0-6.1,1.2-8.6,3.5l-3.1-5.5c3.6-3.3,8.3-4.7,13-4.7c6.8,0,13,2.7,13,11.3v19.2H157.6z M157.6,55.5
			v-3.7c-1.3-1.7-3.8-2.6-6.3-2.6c-3.1,0-5.6,1.7-5.6,4.5c0,2.8,2.5,4.4,5.6,4.4C153.9,58.1,156.3,57.2,157.6,55.5z"
                  />
                  <path
                    class="st3"
                    d="M192.7,62.6v-18c0-4.1-2.2-5.5-5.5-5.5c-3.1,0-5.4,1.7-6.8,3.4v20.1h-7.8V32.9h7.8v3.8
			c1.9-2.2,5.6-4.6,10.4-4.6c6.6,0,9.7,3.7,9.7,9.5v21C200.5,62.6,192.7,62.6,192.7,62.6z"
                  />
                  <path
                    class="st3"
                    d="M225.6,62.6v-3.1c-2,2.5-5.5,3.9-9.4,3.9c-4.7,0-10.3-3.2-10.3-9.8c0-7,5.5-9.6,10.3-9.6c4,0,7.4,1.3,9.4,3.6
			v-3.8c0-3-2.6-5-6.5-5c-3.1,0-6.1,1.2-8.6,3.5l-3.1-5.5c3.6-3.3,8.3-4.7,13-4.7c6.8,0,13,2.7,13,11.3v19.2H225.6z M225.6,55.5
			v-3.7c-1.3-1.7-3.8-2.6-6.3-2.6c-3.1,0-5.6,1.7-5.6,4.5c0,2.8,2.5,4.4,5.6,4.4C221.9,58.1,224.3,57.2,225.6,55.5z"
                  />
                  <path class="st3" d="M241.7,62.6v-41h7.8v41H241.7z" />
                  <path
                    class="st3"
                    d="M253.9,47.7c0-8.4,5.9-15.6,15.7-15.6s15.8,7.1,15.8,15.6s-5.9,15.6-15.8,15.6
			C259.8,63.3,253.9,56.2,253.9,47.7z M277.2,47.7c0-4.6-2.7-8.6-7.6-8.6s-7.6,4-7.6,8.6c0,4.7,2.7,8.7,7.6,8.7
			C274.5,56.4,277.2,52.4,277.2,47.7z"
                  />
                  <path
                    class="st3"
                    d="M291.1,70.2l3.5-5.6c2.4,2.6,5.6,3.6,9.3,3.6c3.8,0,8.2-1.6,8.2-7.6v-2.9c-2.3,3-5.5,4.6-9.2,4.6
			c-7.4,0-13.1-5.2-13.1-15.1c0-9.7,5.6-15.1,13.1-15.1c3.6,0,6.8,1.5,9.2,4.6V33h7.8v27.7c0,11.3-8.7,14-16.1,14
			C298.9,74.6,294.9,73.4,291.1,70.2z M312.2,52.1v-9.7c-1.4-1.9-4.2-3.3-6.7-3.3c-4.5,0-7.6,3.1-7.6,8.2s3.1,8.2,7.6,8.2
			C308,55.5,310.8,54,312.2,52.1z"
                  />
                  <path
                    class="st3"
                    d="M326.4,25c0-2.6,2.1-4.6,4.6-4.6c2.6,0,4.7,2,4.7,4.6s-2.1,4.7-4.7,4.7C328.5,29.7,326.4,27.6,326.4,25z
			 M327.2,62.6V32.9h7.8v29.7C335,62.6,327.2,62.6,327.2,62.6z"
                  />
                </g>
                <g>
                  <path class="st2" d="M107,0l-2.8,17.2h-1.6L105.4,0H107z" />
                  <path
                    class="st2"
                    d="M111.3,9.2l-1.3,8h-1.6l2.1-12.9h1.5l-0.5,3l-0.2,0c0.5-1.1,1.2-1.9,2-2.4s1.7-0.7,2.7-0.7
			c0.9,0,1.6,0.2,2.3,0.6c0.6,0.4,1,0.9,1.3,1.6c0.3,0.7,0.3,1.6,0.1,2.6l-1.4,8.3h-1.6l1.4-8.3c0.2-1.1,0-1.9-0.4-2.5
			s-1.2-0.9-2.2-0.9c-0.7,0-1.3,0.1-1.9,0.4c-0.6,0.3-1.1,0.7-1.5,1.3S111.4,8.5,111.3,9.2z"
                  />
                  <path
                    class="st2"
                    d="M125.2,9.2l-1.3,8h-1.6l2.1-12.9h1.5l-0.5,3l-0.2,0c0.5-1.1,1.2-1.9,2-2.4c0.8-0.5,1.7-0.7,2.7-0.7
			c0.9,0,1.6,0.2,2.3,0.6c0.6,0.4,1,0.9,1.3,1.6s0.3,1.6,0.1,2.6l-1.4,8.3h-1.6l1.4-8.3c0.2-1.1,0-1.9-0.4-2.5
			c-0.5-0.6-1.2-0.9-2.2-0.9c-0.7,0-1.3,0.1-1.9,0.4c-0.6,0.3-1.1,0.7-1.5,1.3C125.6,7.8,125.4,8.5,125.2,9.2z"
                  />
                  <path
                    class="st2"
                    d="M141.3,17.5c-1,0-1.8-0.2-2.6-0.7c-0.7-0.4-1.3-1.1-1.7-1.8s-0.6-1.7-0.6-2.8c0-1,0.2-2,0.5-3
			s0.8-1.8,1.4-2.6s1.3-1.4,2.2-1.8s1.8-0.7,2.8-0.7c1,0,1.8,0.2,2.6,0.7c0.7,0.4,1.3,1.1,1.7,1.8c0.4,0.8,0.6,1.7,0.6,2.8
			c0,1-0.2,2-0.5,3c-0.3,1-0.8,1.8-1.4,2.6s-1.3,1.4-2.2,1.8S142.4,17.5,141.3,17.5z M141.4,16c0.8,0,1.5-0.2,2.2-0.6
			c0.6-0.4,1.2-0.9,1.6-1.6c0.4-0.6,0.8-1.4,1-2.1c0.2-0.8,0.4-1.5,0.4-2.3c0-0.7-0.1-1.4-0.4-2c-0.2-0.6-0.6-1.1-1.1-1.4
			c-0.5-0.3-1.1-0.5-1.8-0.5c-0.8,0-1.5,0.2-2.2,0.6c-0.6,0.4-1.2,0.9-1.6,1.6s-0.8,1.4-1,2.1s-0.4,1.6-0.4,2.4c0,1.1,0.3,2,0.8,2.8
			S140.3,16,141.4,16z"
                  />
                  <path
                    class="st2"
                    d="M153.6,17.2l-2.8-12.9h1.6l1.6,8.1c0.1,0.7,0.3,1.4,0.4,2.2s0.2,1.4,0.3,2.1h-0.6c0.3-0.7,0.7-1.4,1-2.1
			s0.7-1.4,1.1-2.2l4.3-8.1h1.8l-7.1,12.9H153.6z"
                  />
                  <path
                    class="st2"
                    d="M167.1,17.5c-1.1,0-1.9-0.3-2.6-0.8c-0.7-0.6-1.2-1.3-1.5-2.4s-0.3-2.2-0.1-3.5c0.2-1.3,0.6-2.5,1.3-3.5
			s1.4-1.8,2.3-2.3c0.9-0.6,1.9-0.8,2.9-0.8c0.8,0,1.4,0.1,1.9,0.4c0.5,0.3,0.8,0.6,1.1,1c0.2,0.4,0.4,0.8,0.5,1.2h0.1l0.4-2.5h1.6
			l-2.1,12.9h-1.5l0.4-2.4h-0.2c-0.2,0.4-0.6,0.8-1,1.2c-0.4,0.4-0.9,0.8-1.4,1C168.5,17.3,167.8,17.5,167.1,17.5z M167.5,16
			c0.8,0,1.6-0.2,2.2-0.7c0.6-0.5,1.2-1.1,1.6-1.9s0.7-1.7,0.9-2.7s0.2-1.9,0-2.7c-0.2-0.8-0.5-1.4-1-1.8c-0.5-0.4-1.2-0.7-2-0.7
			c-0.9,0-1.6,0.2-2.3,0.7c-0.7,0.5-1.2,1.1-1.6,1.9c-0.4,0.8-0.7,1.7-0.9,2.6c-0.2,1-0.2,1.9,0,2.7c0.2,0.8,0.5,1.4,1,1.9
			C166,15.8,166.7,16,167.5,16z"
                  />
                  <path
                    class="st2"
                    d="M183.2,4.3L183,5.7h-6.1l0.2-1.4H183.2z M179.5,1.2h1.6L179,14.1c-0.1,0.7,0,1.1,0.2,1.4
			c0.2,0.3,0.7,0.4,1.2,0.3c0.1,0,0.2,0,0.4,0c0.2,0,0.3-0.1,0.5-0.1l0.1,1.3c-0.2,0-0.3,0.1-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.1
			c-1.1,0.1-1.8-0.2-2.3-0.7c-0.5-0.6-0.6-1.3-0.5-2.3L179.5,1.2z"
                  />
                  <path
                    class="st2"
                    d="M188.8,17.4c-1,0-1.9-0.2-2.6-0.6c-0.7-0.4-1.3-1-1.7-1.8c-0.4-0.8-0.6-1.7-0.6-2.7c0-1.2,0.2-2.2,0.5-3.2
			c0.4-1,0.8-1.9,1.5-2.6c0.6-0.8,1.4-1.3,2.2-1.8s1.8-0.6,2.8-0.6c0.8,0,1.5,0.1,2.1,0.4s1,0.7,1.4,1.2c0.3,0.5,0.5,1.1,0.5,1.8
			c0,0.8-0.2,1.4-0.6,1.9c-0.4,0.5-1,0.9-1.8,1.2c-0.8,0.3-1.8,0.5-3.1,0.6c-1.2,0.1-2.7,0.2-4.3,0.2l0.2-1.2c1.4,0,2.6,0,3.7-0.1
			s1.9-0.2,2.5-0.4c0.7-0.2,1.1-0.5,1.4-0.8c0.3-0.4,0.5-0.8,0.5-1.4c0-0.6-0.2-1.1-0.7-1.4s-1.1-0.5-1.8-0.5
			c-0.9,0-1.7,0.2-2.3,0.6c-0.7,0.4-1.2,0.9-1.7,1.6c-0.4,0.7-0.8,1.4-1,2.2s-0.3,1.6-0.3,2.4c0,0.7,0.1,1.3,0.4,1.9s0.6,1,1.2,1.3
			c0.5,0.3,1.2,0.5,1.9,0.5c0.8,0,1.6-0.2,2.3-0.6s1.2-0.9,1.6-1.5l1.4,0.5c-0.5,0.9-1.3,1.6-2.2,2.2
			C191,17.2,189.9,17.4,188.8,17.4z"
                  />
                  <path
                    class="st2"
                    d="M201.7,17.5c-1.4,0-2.4-0.5-3.2-1.4c-0.8-0.9-1.2-2.2-1.2-3.7c0-1,0.1-2,0.4-2.9s0.7-1.9,1.3-2.6
			c0.6-0.8,1.2-1.4,2-1.9c0.8-0.5,1.7-0.7,2.7-0.7c0.8,0,1.4,0.1,1.9,0.4c0.5,0.3,0.9,0.6,1.1,1c0.3,0.4,0.4,0.8,0.5,1.2h0.1
			l1.1-6.8h1.6l-2.8,17.2h-1.5l0.4-2.4H206c-0.2,0.4-0.5,0.8-0.9,1.3c-0.4,0.4-0.8,0.8-1.4,1C203.1,17.3,202.4,17.5,201.7,17.5z
			 M201.9,16c0.8,0,1.5-0.2,2.2-0.6c0.6-0.4,1.1-0.9,1.6-1.6c0.4-0.7,0.7-1.4,1-2.2c0.2-0.8,0.3-1.6,0.3-2.4c0-1.1-0.3-2-0.8-2.7
			s-1.3-1-2.3-1c-0.8,0-1.5,0.2-2.1,0.6c-0.6,0.4-1.1,0.9-1.6,1.6s-0.8,1.4-1,2.2c-0.2,0.8-0.3,1.6-0.3,2.4c0,1.1,0.3,2,0.8,2.7
			S200.9,16,201.9,16z"
                  />
                  <path
                    class="st2"
                    d="M223.6,17.5c-0.8,0-1.4-0.1-1.9-0.4s-0.9-0.6-1.1-1c-0.3-0.4-0.5-0.8-0.6-1.2h-0.2l-0.4,2.4h-1.5L220.7,0h1.6
			l-1.1,6.8h0.1c0.2-0.4,0.6-0.8,0.9-1.2c0.4-0.4,0.8-0.7,1.4-1c0.5-0.3,1.2-0.4,2-0.4c0.9,0,1.7,0.2,2.4,0.6c0.7,0.4,1.2,1,1.5,1.8
			c0.4,0.8,0.5,1.7,0.5,2.7c0,1-0.1,2-0.4,2.9c-0.3,1-0.7,1.9-1.3,2.7c-0.6,0.8-1.2,1.4-2,1.9S224.6,17.5,223.6,17.5z M223.4,16
			c0.8,0,1.5-0.2,2.1-0.6c0.6-0.4,1.1-0.9,1.6-1.6c0.4-0.7,0.8-1.4,1-2.2c0.2-0.8,0.3-1.6,0.3-2.4c0-1.1-0.3-2-0.8-2.7s-1.3-1-2.3-1
			c-0.8,0-1.5,0.2-2.1,0.6c-0.6,0.4-1.1,0.9-1.6,1.6s-0.7,1.4-1,2.2c-0.2,0.8-0.3,1.6-0.3,2.4c0,1.1,0.3,2,0.8,2.7
			S222.4,16,223.4,16z"
                  />
                  <path
                    class="st2"
                    d="M230.5,21.8l0.7-1.4l0.2,0c0.4,0.1,0.9,0.2,1.3,0.1c0.4-0.1,0.8-0.2,1.1-0.6s0.7-0.8,1-1.4l0.7-1.4l-2.8-13
			h1.6l1.6,8.1c0.1,0.7,0.3,1.5,0.4,2.2s0.2,1.4,0.3,2.1h-0.6c0.3-0.7,0.7-1.4,1-2.1s0.7-1.5,1.1-2.2l4.3-8.1h1.8l-8.2,15
			c-0.3,0.6-0.7,1.2-1.1,1.6c-0.4,0.4-0.9,0.7-1.3,0.9c-0.5,0.2-1,0.3-1.5,0.3c-0.3,0-0.6,0-0.8-0.1S230.6,21.9,230.5,21.8z"
                  />
                </g>
              </g>
            </svg>
          </a>
          <span class="copyright">&copy; Tüm hakları saklıdır. </span>
        </div>
      </div>
    </div>
  </div>
</footer>
